export class Serie {
    name: string;
    value: number;
    isForecasted: boolean;

    constructor(name: string, value: number, isForecasted: boolean = false) {
        this.name = name;
        this.value = value;
        this.isForecasted = isForecasted;
    }
}
